import React, { createContext, useState, useEffect, useContext } from "react";
import { auth, googleProvider } from "../services/firebase";
import { signInWithPopup, signOut, onAuthStateChanged } from "firebase/auth";
import toast from "react-hot-toast";

const AuthContext = createContext({});

export const useAuth = () => useContext(AuthContext);

// Authorized email addresses
const AUTHORIZED_EMAILS = [
  "cedrickhuayanhan@gmail.com",
  "isabeljadehuang@gmail.com"
];

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        // Check if user's email is authorized
        if (AUTHORIZED_EMAILS.includes(user.email)) {
          setCurrentUser(user);
        } else {
          // Sign out unauthorized users
          await signOut(auth);
          setCurrentUser(null);
          toast.error("Unauthorized email address. Access denied.");
        }
      } else {
        setCurrentUser(null);
      }
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const signInWithGoogle = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      
      // Check if the email is authorized
      if (AUTHORIZED_EMAILS.includes(result.user.email)) {
        toast.success(`Welcome, ${result.user.displayName}!`);
        return result.user;
      } else {
        // Sign out unauthorized user
        await signOut(auth);
        toast.error("Sorry, your email is not authorized to access this admin panel.");
        return null;
      }
    } catch (error) {
      toast.error("Failed to sign in");
      console.error("Error signing in with Google:", error);
    }
  };

  const logout = async () => {
    try {
      await signOut(auth);
      toast.success("Logged out successfully");
    } catch (error) {
      toast.error("Failed to log out");
      console.error("Error signing out:", error);
    }
  };

  const value = {
    currentUser,
    signInWithGoogle,
    logout,
    isAuthorized: currentUser && AUTHORIZED_EMAILS.includes(currentUser.email),
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};
